import React from 'react';
import { Link } from 'react-router-dom';
import { IFolder } from '../../../types/knowledgeBase.types';
import styles from './KBBreadcrumbs.module.css';

interface KBBreadcrumbsProps {
    folder: IFolder | null | undefined;
    isAdmin: boolean;
}

export const KBBreadcrumbs: React.FC<KBBreadcrumbsProps> = ({ folder, isAdmin }) => {
    // Определяем базовый URL в зависимости от типа пользователя
    const baseUrl = isAdmin ? '/administrator/cabinet/knowledge-base' : '/user/cabinet/knowledge-base';

    if (!folder) {
        return (
            <div className={styles.breadcrumbs}>
                <Link to={baseUrl} className={styles.breadcrumbLink}>
                    База знаний
                </Link>
            </div>
        );
    }
    
    return (
        <div className={styles.breadcrumbs}>
            <Link to={baseUrl} className={styles.breadcrumbLink}>
                База знаний
            </Link>
            
            {/* Разделитель */}
            <span className={styles.separator}>{'>'}</span>
            
            {/* Родительские папки (предки) */}
            {folder.ancestors && folder.ancestors.length > 0 && folder.ancestors.map((ancestor, index) => (
                <React.Fragment key={ancestor._id}>
                    <Link 
                        to={`${baseUrl}/${ancestor._id}`}
                        className={styles.breadcrumbLink}
                    >
                        {ancestor.name}
                    </Link>
                    <span className={styles.separator}>{'>'}</span>
                </React.Fragment>
            ))}
            
            {/* Текущая папка (без ссылки) */}
            <span className={styles.currentFolder}>
                {folder.name}
            </span>
        </div>
    );
};
